import { createTypes } from "reduxsauce";

const prefix = "APP/";

export const STATE_STATUS = {
  UNFETCHED: "UNFETCHED",
  FETCHED: "FETCHED",
  FULL_FETCHED: "FULL_FETCHED",
  FETCHING: "FETCHING",
  FETCH_FAILED: "FETCH_FAILED",

  NOT_CREATED: "NOT_CREATED",
  CREATING: "CREATING",
  CREATED: "CREATED",
  CREATE_FAILED: "CREATE_FAILED",

  UPDATING: "UPDATING",
  UPDATED: "UPDATED",
  UPDATE_FAILED: "UPDATE_FAILED",

  EDITING: "EDITING",
  EDITED: "EDITED",
  EDIT_FAILED: "EDIT_FAILED",
  NOT_STARTED: "NOT_STARTED",

  IDLE: "IDLE",
  ENGAGED: "ENGAGED",
  FAILED: "FAILED",
  SUCCEEDED: "SUCCEEDED",
};

export const INVOKE_APP_SETUP = "INVOKE_APP_SETUP";
export const CLEAR_APP_SETUP = "CLEAR_APP_SETUP";

export const DISABLE_EARLY_JOURNEY_WHEN_COMPLETE =
  "DISABLE_EARLY_JOURNEY_WHEN_COMPLETE";
export const DISABLE_INITIAL_JOURNEY_WHEN_COMPLETE =
  "DISABLE_INITIAL_JOURNEY_WHEN_COMPLETE";
export const UPDATE_SHOWCMS1 = "UPDATE_SHOWCMS1";
export const UPDATE_SHOW_ADDRESS_SCREEN = "UPDATE_SHOW_ADDRESS_SCREEN";
export const SET_CMOCX_DATA = "SET_CMOCX_DATA";

export const UPDATE_STAR_CP_ACTIVE_ROUTE = "UPDATE_STAR_CP_ACTIVE_ROUTE";

export const AUTH_ACTIONS = {
  RESTORE_TOKEN: "RESTORE_TOKEN",
  SIGN_IN: "SIGN_IN",
  SIGN_OUT: "SIGN_OUT",
  RESTORE_USER_TOKEN: "RESTORE_USER_TOKEN",
  SIGN_OUT_USER: "SIGN_OUT_USER",
  SET_NEW_USER_REQUEST: "SET_NEW_USER_REQUEST",
  SET_NEW_USER: "SET_NEW_USER",
  REMOVE_NEW_USER_REQUEST: "REMOVE_NEW_USER_REQUEST",
  REMOVE_NEW_USER: "REMOVE_NEW_USER",
};

export const SYNC_USER_ACTIONS = {
  FETCH_SYNC_USER: "FETCH_SYNC_USER",
  FETCHED_SYNC_USER: "FETCHED_SYNC_USER",
  FAILED_FETCH_SYNC_USER: "FAILED_FETCH_SYNC_USER",
};

// Auth Action Types
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const DUMMY_LOGIN_REQUEST = "DUMMY_LOGIN_REQUEST";
export const SET_USER_NUMBER_FOR_LOGIN = "SET_USER_NUMBER_FOR_LOGIN";
export const GET_USER_DETAILS_BY_TOKEN_REQUEST =
  "GET_USER_DETAILS_BY_TOKEN_REQUEST";
export const GET_USER_DETAILS_BY_TOKEN_SUCCESS =
  "GET_USER_DETAILS_BY_TOKEN_SUCCESS";
export const UPDATE_BASIC_INFO_IN_USER = "UPDATE_BASIC_INFO_IN_USER";
export const SET_NEW_REGISTRATION_DETAILS = "SET_NEW_REGISTRATION_DETAILS";
export const SET_BRANCH_IO_PARAMS = "SET_BRANCH_IO_PARAMS";
export const RESET_BRANCH_IO_PARAMS = "RESET_BRANCH_IO_PARAMS";
export const SET_FETCH_ME_COMPLETED = "SET_FETCH_ME_COMPLETED";
export const RESET_FETCH_ME_COMPLETED = "RESET_FETCH_ME_COMPLETED";
export const SHOW_SUSPENSION_MODAL = "SHOW_SUSPENSION_MODAL";

// product related types
export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";

export const PLACE_NEW_ORDER_REQUEST = "PLACE_NEW_ORDER_REQUEST";
export const PLACE_NEW_ORDER_SUCCESS = "PLACE_NEW_ORDER_SUCCESS";
export const GET_ALL_PLACED_ORDERS_REQUEST = "GET_ALL_PLACED_ORDERS_REQUEST";
export const GET_ALL_PLACED_ORDERS_SUCCESS = "GET_ALL_PLACED_ORDERS_SUCCESS";

export const GET_MORE_PLACED_ORDERS_REQUEST = "GET_MORE_PLACED_ORDERS_REQUEST";
export const GET_MORE_PLACED_ORDERS_SUCCESS = "GET_MORE_PLACED_ORDERS_SUCCESS";

export const GET_SEARCHED_PRODUCTS_REQUEST = "GET_SEARCHED_PRODUCTS_REQUEST";
export const GET_SEARCHED_PRODUCTS_SUCCESS = "GET_SEARCHED_PRODUCTS_SUCCESS";
export const RESET_SEARCHED_PRODUCTS = "RESET_SEARCHED_PRODUCTS";

export const SET_SELECTED_PLACED_ORDER = "SET_SELECTED_PLACED_ORDER";
export const SET_ORDER_DETAILS = "SET_ORDER_DETAILS";

export const FETCH_REQUEST_FOR_PRODUCT_REQUEST =
  "FETCH_REQUEST_FOR_PRODUCT_REQUEST";
export const FETCH_REQUEST_FOR_PRODUCT_SUCCESS =
  "FETCH_REQUEST_FOR_PRODUCT_SUCCESS";
export const RESET_PRODUCT_REQUESTS = "RESET_PRODUCT_REQUESTS";
export const GET_OOS_SKUS_REQUEST = "GET_OOS_SKUS_REQUEST";
export const GET_OOS_SKUS_SUCCESS = "GET_OOS_SKUS_SUCCESS";

// product details type
export const GET_PRODUCT_DETAILS_REQUEST = "GET_PRODUCT_DETAILS_REQUEST";
export const GET_PRODUCT_DETAILS_SUCCESS = "GET_PRODUCT_DETAILS_SUCCESS";
export const UPDATE_PRODUCT_QUANTITY = "UPDATE_PRODUCT_QUANTITY";
export const SELECT_PAYMENT_MODE = "SELECT_PAYMENT_MODE";
export const IS_SUSCRIBED = "IS_SUSCRIBED";

// order related types
export const SET_ADDRESS_OF_USER = "SET_ADDRESS_OF_USER";
export const SET_SELECTED_ORDER = "SET_SELECTED_ORDER";
export const EMPTY_ORDER_LIST = "EMPTY_ORDER_LIST";
export const FETCH_ORDER_CANCELLATION_REASONS_REQUEST =
  "FETCH_ORDER_CANCELLATION_REASONS_REQUEST";
export const FETCH_ORDER_CANCELLATION_REASONS_SUCCESS =
  "FETCH_ORDER_CANCELLATION_REASONS_SUCCESS";

// support related types
export const SET_USER_QUERY = "SET_USER_QUERY";
export const SET_ORDER_ID = "SET_ORDER_ID";
export const SUBMIT_COMMENT = "SUBMIT_COMMENT";

// Bank accounts types
export const ADD_USER_BANK_ACCOUNT_REQUEST = "ADD_USER_BANK_ACCOUNT_REQUEST";
export const ADD_USER_BANK_ACCOUNT_SUCCESS = "ADD_USER_BANK_ACCOUNT_SUCCESS";
export const DELETED_BANK_ACCOUNT_DETAILS = "DELETED_BANK_ACCOUNT_DETAILS";
export const DELETED_BANK_ACCOUNT_DETAILS_SUCCESS =
  "DELETED_BANK_ACCOUNT_DETAILS_SUCCESS";

// Leader related types
export const ADD_TL_USER = "ADD_TL_USER";
export const ADD_TL_USER_SUCCESS = "ADD_TL_USER_SUCCESS";
export const GET_ALL_TL_USERS = "GET_ALL_TL_USERS";
export const SET_ALL_TL_USERS = "SET_ALL_TL_USERS";
export const DELETE_TL_USER = "DELETE_TL_USER";
export const DELETE_TL_USER_SUCCESS = "DELETE_TL_USER_SUCCESS";
export const GET_TOTAL_PAYOUT_REQUEST = "GET_TOTAL_PAYOUT_REQUEST";
export const GET_TOTAL_PAYOUT_SUCCESS = "GET_TOTAL_PAYOUT_SUCCESS";
export const GET_DAILY_SALES_REQUEST = "GET_DAILY_SALES_REQUEST";
export const GET_DAILY_SALES_SUCCESS = "GET_DAILY_SALES_SUCCESS";
export const GET_DAILY_PAYOUT_REQUEST = "GET_DAILY_PAYOUT_REQUEST";
export const GET_DAILY_PAYOUT_SUCCESS = "GET_DAILY_PAYOUT_SUCCESS";
export const SET_OFFSET_Y = "SET_OFFSET_Y";

// general config related types
export const SET_HEADER_TITLE = "SET_HEADER_TITLE";

// cart retated types
export const SET_CUSTOMER_FOR_NEW_ORDER = "SET_CUSTOMER_FOR_NEW_ORDER";
export const ADD_NEW_ITEM_CART_REQUEST = "ADD_NEW_ITEM_CART_REQUEST";
export const ADD_NEW_ITEM_CART_SUCCESS = "ADD_NEW_ITEM_CART_SUCCESS";
export const GET_ALL_CART_ITEMS_REQUEST = "GET_ALL_CART_ITEMS_REQUEST";
export const GET_ALL_CART_ITEMS_SUCCESS = "GET_ALL_CART_ITEMS_SUCCESS";
export const TOGGLE_CART_FETCHING = "TOGGLE_CART_FETCHING";
export const VIEW_CART_FETCHING = "VIEW_CART_FETCHING";
export const RESET_CART = "RESET_CART";
export const SET_CUSTOMER_FOR_NEW_ORDER_DATA =
  "SET_CUSTOMER_FOR_NEW_ORDER_DATA";
export const SET_NEW_COUPON = "SET_NEW_COUPON";
export const VIEW_CART_LITE_REQUEST = "VIEW_CART_LITE_REQUEST";
export const VIEW_CART_LITE_SUCCESS = "VIEW_CART_LITE_SUCCESS";

// Categories related
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const GET_ALL_CATEGORIES_SUCCESS = "GET_ALL_CATEGORIES_SUCCESS";
export const GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_REQUEST =
  "GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_REQUEST";
export const GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_SUCCESS =
  "GET_ALL_PRIMARY_CATEGORIES_WITH_PRODUCT_TYPES_SUCCESS";

// SNACKBAR MESSAGES
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";

// RESET REDUCERS
export const RESET_PERSISTED_STORAGE = "RESET_PERSISTED_STORAGE";
export const RESET_PRODUCTS_STATE = "RESET_PRODUCTS_STATE";
export const RESET_SELECTED_PRODUCT_STATE = "RESET_SELECTED_PRODUCT_STATE";
export const RESET_ORDERS_STATE = "RESET_ORDERS_STATE";
export const RESET_LEADER_STATE = "RESET_LEADER_STATE";
export const RESET_CONFIG_STATE = "RESET_CONFIG_STATE";
export const RESET_CART_STATE = "RESET_CART_STATE";
export const RESET_SHARE_STATE = "RESET_SHARE_STATE";
export const RESET_TABS_STATE = "RESET_TABS_STATE";
export const RESET_CATEGORIES_STATE = "RESET_CATEGORIES_STATE";
export const RESET_SNACKBAR = "RESET_SNACKBAR";
export const RESET_AUTH_STATE = "RESET_AUTH_STATE";

// MISC TYPES
export const SHOW_SETTINGS_MODAL = "SHOW_SETTINGS_MODAL";
export const HIDE_SETTINGS_MODAL = "HIDE_SETTINGS_MODAL";
export const SET_EMERGENCY_MESSAGE_REQUEST = "SET_EMERGENCY_MESSAGE_REQUEST";
export const SET_EMERGENCY_MESSAGE_SUCCESS = "SET_EMERGENCY_MESSAGE_SUCCESS";
export const RESET_EMERGENCY_MESSAGE = "RESET_EMERGENCY_MESSAGE";
export const SHOW_NOT_ONBOARDED_STATUS_MODAL_VISIBLE =
  "SHOW_NOT_ONBOARDED_STATUS_MODAL_VISIBLE";
export const HIDE_NOT_ONBOARDED_STATUS_MODAL_VISIBLE =
  "HIDE_NOT_ONBOARDED_STATUS_MODAL_VISIBLE";
export const SHOW_NOT_ONBOARDED_STATUS_BAR_VISIBLE =
  "SHOW_NOT_ONBOARDED_STATUS_BAR_VISIBLE";
export const HIDE_NOT_ONBOARDED_STATUS_BAR_VISIBLE =
  "HIDE_NOT_ONBOARDED_STATUS_BAR_VISIBLE";
export const SHOW_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE =
  "SHOW_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE";
export const HIDE_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE =
  "HIDE_ORDER_CANCEL_SUCCESS_MODAL_VISIBLE";
export const SET_UPDATE_GROUP_BUY_CUSTOMERS_LIST =
  "SET_UPDATE_GROUP_BUY_CUSTOMERS_LIST";
export const RESET_UPDATE_GROUP_BUY_CUSTOMERS_LIST =
  "RESET_UPDATE_GROUP_BUY_CUSTOMERS_LIST";
export const SET_HOME_MOUNTED = "SET_HOME_MOUNTED";
export const SET_HOME_UNMOUNTED = "SET_HOME_UNMOUNTED";
export const SET_ONBOARDED_APP = "SET_ONBOARDED_APP";
export const RESET_ONBOARDED_APP = "RESET_ONBOARDED_APP";
export const SET_SHOULD_SHOW_SUPPORT_MODAL_VISIBLE =
  "SET_SHOULD_SHOW_SUPPORT_MODAL_VISIBLE";
export const RESET_SHOULD_SHOW_SUPPORT_MODAL_VISIBLE =
  "RESET_SHOULD_SHOW_SUPPORT_MODAL_VISIBLE";
export const SET_CAN_OPEN_HTTP_URLS = "SET_CAN_OPEN_HTTP_URLS";

// SUPPORT_NEW
export const UPDATE_SUPPORT_TICKET_PAYLOAD = "UPDATE_SUPPORT_TICKET_PAYLOAD";
export const RESET_SUPPORT_TICKET_PAYLOAD = "RESET_SUPPORT_TICKET_PAYLOAD";
export const SHOW_CREATE_TICKET = "SHOW_CREATE_TICKET";
export const SET_TOP_LEVEL_KEY = "SET_TOP_LEVEL_KEY";
export const SET_SUPPORT_CONFIGS = "SET_SUPPORT_CONFIGS";
export const GET_SUPPORT_CONFIGS = "GET_SUPPORT_CONFIGS";
export const SET_DISSAT_REASONS = "SET_DISSAT_REASONS";

// VideoBanner
export const PAUSE_ALL_VIDEO_BANNERS = "PAUSE_ALL_VIDEO_BANNERS";

// Order details refresh data after rating
export const REFETCH_ORDER_DETAILS = "REFETCH_ORDER_DETAILS";

// Nav
export const NAVIGATE = "NAVIGATE";
export const SET_HOME_NAV_MOUNTED = "SET_HOME_NAV_MOUNTED";
export const SET_MAIN_NAV_MOUNTED = "SET_MAIN_NAV_MOUNTED";
export const SET_CURRENT_ROUTE_NAME = "SET_CURRENT_ROUTE_NAME";

// DEEP LINKS
export const HANDLE_DEEP_LINK = "HANDLE_DEEP_LINK";
export const HANDLE_DEEP_LINK_NAVIGATION = "HANDLE_DEEP_LINK_NAVIGATION";
export const SET_DEEP_LINK_PARAMS = "SET_DEEP_LINK_PARAMS";

// WALLET

export const GET_FUND_ACCOUNTS_ACTIONS = {
  FETCH_FUND_ACCOUNTS: "FETCH_FUND_ACCOUNTS",
  FAILED_FETCH_FUND_ACCOUNTS: "FAILED_FETCH_FUND_ACCOUNTS",
  FETCHED_FUND_ACCOUNTS: "FETCHED_FUND_ACCOUNTS",
};

export const CREATE_FUND_ACCOUNT_VPA_ACTIONS = {
  CREATE_VPA_FUND_ACCOUNT: "CREATE_VPA_FUND_ACCOUNT",
  FAILED_CREATE_VPA_FUND_ACCOUNT: "FAILED_CREATE_VPA_FUND_ACCOUNT",
  SUCCESS_CREATE_VPA_FUND_ACCOUNTS: "SUCCESS_CREATE_VPA_FUND_ACCOUNTS",
  RESET_CREATE_VPA_FUND_ACCOUNT: "RESET_CREATE_VPA_FUND_ACCOUNT",
};

export const CREATE_FUND_ACCOUNT_BANK_ACTIONS = {
  CREATE_FUND_ACCOUNT: "CREATE_FUND_ACCOUNT",
  FAILED_CREATE_FUND_ACCOUNT: "FAILED_CREATE_FUND_ACCOUNT",
  SUCCESS_CREATE_FUND_ACCOUNTS: "SUCCESS_CREATE_FUND_ACCOUNTS",
  RESET_CREATE_FUND_ACCOUNT: "RESET_CREATE_FUND_ACCOUNT",
};

export const WITHDRAW_MONEY_ACTIONS = {
  WITHDRAW_MONEY: "WITHDRAW_MONEY",
  FAILED_WITHDRAW_MONEY: "FAILED_WITHDRAW_MONEY",
  SUCCESS_WITHDRAW_MONEY: "SUCCESS_WITHDRAW_MONEY",
  RESET_WITHDRAW_MONEY: "RESET_WITHDRAW_MONEY",
};

export const DELAYED_DATA_ACTIONS = {
  FETCH_DELAYED_DATA: "FETCH_DELAYED_DATA",
  FETCHED_DELAYED_DATA: "FETCHED_DELAYED_DATA",
  FAILED_FETCH_DELAYED_DATA: "FAILED_FETCH_DELAYED_DATA",
  DELIVERY_FLOW_ENABLED: "DELIVERY_FLOW_ENABLED",
  GET_DELIVERY_INFO: "GET_DELIVERY_INFO",
  CONFIRM_LOGIN_DEVICE: "CONFIRM_LOGIN_DEVICE",
  UPDATE_CP_AVAILABILITY_MODAL: "UPDATE_CP_AVAILABILITY_MODAL",
};

// CCFP
export const FETCH_CCFP_SUMMARY_REQ = "FETCH_CCFP_SUMMARY_REQ";
export const SET_CCFP_SUMMARY = "SET_CCFP_SUMMARY";
export const FETCH_CCFP_SUMMARY_FAILED = "FETCH_CCFP_SUMMARY_FAILED";

export const WITHDRAW_CCFP_MONEY = "WITHDRAW_CCFP_MONEY";
export const WITHDRAW_CCFP_MONEY_SUCCESS = "WITHDRAW_CCFP_MONEY_SUCCESS";
export const WITHDRAW_CCFP_MONEY_FAILED = "WITHDRAW_CCFP_MONEY_FAILED";

export const FETCH_CCFP_LANDING_PAGE = "FETCH_CCFP_LANDING_PAGE";
export const FETCH_CCFP_LANDING_PAGE_SUCCESS =
  "FETCH_CCFP_LANDING_PAGE_SUCCESS";
export const FETCH_CCFP_LANDING_PAGE_ERROR = "FETCH_CCFP_LANDING_PAGE_ERROR";

export const FETCH_PASSBOOK = "FETCH_PASSBOOK";
export const FETCH_PASSBOOK_SUCCESS = "FETCH_PASSBOOK_SUCCESS";
export const FETCH_PASSBOOK_ERROR = "FETCH_PASSBOOK_ERROR";

// WALLET
export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER";
export const SET_CURRENT_WALLET_SCREEN = "SET_CURRENT_WALLET_SCREEN";
export const SET_WALLET_META_DATA = "SET_WALLET_META_DATA";
export const SET_WALLET_SUMMARY = "SET_WALLET_SUMMARY";

// HOME ACTIONS

export const GET_HOMEPAGE_REQ = "GET_HOMEPAGE_REQ";
export const GET_HOMEPAGE_SUCCESS = "GET_HOMEPAGE_SUCCESS";
export const GET_HOMEPAGE_FAIL = "GET_HOMEPAGE_FAIL";

// APP Settings
export const GET_APP_SETTINGS = "GET_APP_SETTINGS";
export const SET_APP_SETTINGS = "SET_APP_SETTINGS";
export const GET_APP_BOOT_PARAMS = "GET_APP_BOOT_PARAMS";
export const GET_APP_BOOT_PARAMS2 = "GET_APP_BOOT_PARAMS2";

// Contact Related Types
export const SET_CONTACT_PERMISSION_STATUS_SUCCESS =
  "SET_CONTACT_PERMISSION_STATUS_SUCCESS";
export const SET_CONTACT_PERMISSION_STATUS = "SET_CONTACT_PERMISSION_STATUS";
export const SET_SELECTED_CONTACT = "SET_SELECTED_CONTACT";
export const SET_SELECTED_CONTACT_SUCCESS = "SET_SELECTED_CONTACT_SUCCESS";

// qty select bottom view related

export const SHOW_QTY_SELECTOR = "SHOW_QTY_SELECTOR";
export const HIDE_QTY_SELECTOR = "HIDE_QTY_SELECTOR";
export const SET_DISPLAY_ID = "SET_DISPLAY_ID";

export const SET_COMMISSION = "SET_COMMISSION";

export const SHOW_PAY_NOW_MODAL = "SHOW_PAY_NOW_MODAL";

export const HIDE_PAY_NOW_MODAL = "HIDE_PAY_NOW_MODAL";

export const SHOW_PAY_NOW_SUCCESS = "SHOW_PAY_NOW_SUCCESS";

export const RESET_PAY_NOW_MODAL_RESET = "RESET_PAY_NOW_MODAL_RESET";

export const UPDATE_RECENT_SEARCH_DATA = "UPDATE_RECENT_SEARCH_DATA";

// LGL

export const GET_LGL_REQ = "GET_LGL_REQ";
export const GET_LGL_SUCCESS = "GET_LGL_SUCCESS";
export const GET_LGL_FAIL = "GET_LGL_FAIL";

export const SET_NOTIFICATION_INDICATOR = "SET_NOTIFICATION_INDICATOR";

// Nudge

export const SET_NUDGE = "SET_NUDGE";
export const SET_NUDGE_SUCCESS = "SET_NUDGE_SUCCESS";

export const UPDATE_VIEWED_STORIES = "UPDATE_VIEWED_STORIES";
export const CLEAR_VIEWED_STORIES = "CLEAR_VIEWED_STORIES";
export const HYDRATE_VIEWED_STORES = "HYDRATE_VIEWED_STORES";

export const SET_MINIMUM_POST_VIEW_TIME = "SET_MINIMUM_POST_VIEW_TIME";

export const SET_WALL_RENDER = "SET_WALL_RENDER";
export const SET_POLL = "SET_POLL";
export const SET_REFRESH_TIMESTAMP = "SET_REFRESH_TIMESTAMP";
export const RESET_REFRESH_TIMESTAMP = "RESET_REFRESH_TIMESTAMP";
export const SET_REFRESH_DURATION = "SET_REFRESH_DURATION";
export const SILENT_REFRESH = "SILENT_REFRESH";
export const TRACK_POST_IMPRESSION = "TRACK_POST_IMPRESSION";
export const PROCESS_PENDING_POST_IMPRESSIONS_DEBOUNCED =
  "PROCESS_PENDING_POST_IMPRESSIONS_DEBOUNCED";
export const PROCESS_PENDING_POST_IMPRESSIONS_IMMEDIATE =
  "PROCESS_PENDING_POST_IMPRESSIONS_IMMEDIATE";
export const SET_FOLLOWING = "SET_FOLLOWING";

export const SET_SHOW_PARIVAAR_NOTIFICATION = "SET_SHOW_PARIVAAR_NOTIFICATION";

// store Leader

export const HANDLE_LEADER_CARD_OPEN = "HANDLE_LEADER_CARD_OPEN";
export const HANDLE_LEADER_CARD_COUNT = "HANDLE_LEADER_CARD_COUNT";
export const SET_SALES_DATA = "SET_SALES_DATA";

// Change Language
export const SET_LANGUAGE = "SET_LANGUAGE";

// RETURN ORDERS LIST TYPES
export const FETCH_RETURN_ORDERS_LIST_REQUEST =
  "FETCH_RETURN_ORDERS_LIST_REQUEST";
export const FETCH_RETURN_ORDERS_LIST_SUCCESS =
  "FETCH_RETURN_ORDERS_LIST_SUCCESS";
export const FETCH_MORE_RETURN_ORDERS_LIST_REQUEST =
  "FETCH_MORE_RETURN_ORDERS_LIST_REQUEST";
export const FETCH__MORE_RETURN_ORDERS_LIST_SUCCESS =
  "FETCH__MORE_RETURN_ORDERS_LIST_SUCCESS";
export const CANCEL_RETURN_REQUEST = "CANCEL_RETURN_REQUEST";
export const RVP_PICKUP_DATE = "RVP_PICKUP_DATE";
export const SET_MODAL_VALUES = "SET_MODAL_VALUES";

export const SET_CLDROPDOWNOPTIONS = "SET_CLDROPDOWNOPTIONS";
export const SET_IMPRESSION_POSTS = "SET_IMPRESSION_POSTS";

// Account Deactivation
export const DEACTIVATE_ACCOUNT = "DEACTIVATE_ACCOUNT";
export const CONTACT_UPDATE = "CONTACT_UPDATE";

// Shop
export const SHOP_ACTIONS = {
  IS_FETCHING: "IS_FETCHING",
  SET_STATS: "SET_STATS",
  SET_CUSTOMERS: "SET_CUSTOMERS",
  SET_ORDERS: "SET_ORDERS",
  SET_UPDATES: "SET_UPDATES",
};
// SHOP PERFORMANCE

export const UPDATE_CUSTOMER_DETAILS = "UPDATE_CUSTOMER_DETAILS";
export const UPDATE_PRODUCT_DETAILS = "UPDATE_PRODUCT_DETAILS";
export const UPDATE_ITEM_DETAILS = "UPDATE_ITEM_DETAILS";
export const UPDATE_SALES = "UPDATE_SALES";
export const UPDATE_COMMISSION = "UPDATE_COMMISSION";

export const UPDATE_SELECTED_MONTH = "UPDATE_SELECTED_MONTH";
export const UPDATE_CURRENT_MONTH = "UPDATE_CURRENT_MONTH";
export const SET_LAST_MONTH_OVERVIEW = "SET_LAST_MONTH_OVERVIEW";
export const ACTIVE_INDEX = "ACTIVE_INDEX";
export const UPDATE_REF1 = "UPDATE_REF1";
export const UPDATE_REF2 = "UPDATE_REF2";
export const UPDATE_REF3 = "UPDATE_REF3";

// applink
export const HANDLE_APPLINK = "HANDLE_APPLINK";
export const APPLINK_CONFIGURED = "APPLINK_CONFIGURED";
export const SET_APPLINK = "SET_APPLINK";

// Cl Tasks
export const GET_REASON_CART_TASK = "GET_REASON_CART_TASK";
export const UPDATE_REASON_CART_TASK = "UPDATE_REASON_CART_TASK";
export const GET_WALLET_BUSINESS_TIPS = "GET_WALLET_BUSINESS_TIPS";
export const UPDATE_WALLET_BUSINESS_TIPS = "UPDATE_WALLET_BUSINESS_TIPS";
export const GET_CART_BUSINESS_TIPS = "GET_CART_BUSINESS_TIPS";
export const UPDATE_CART_BUSINESS_TIPS = "UPDATE_CART_BUSINESS_TIPS";
export const GET_PROMOTION_BUSINESS_TIPS = "GET_PROMOTION_BUSINESS_TIPS";
export const UPDATE_PROMOTION_BUSINESS_TIPS = "UPDATE_PROMOTION_BUSINESS_TIPS";
export const GET_TODAY_TASK = "GET_TODAY_TASK";
export const GET_CL_TASK_SUMMARY = "GET_CL_TASK_SUMMARY";
export const UPDATE_CL_TASK_SUMMARY = "UPDATE_CL_TASK_SUMMARY";
export const GET_CL_TASK_DATA = "GET_CL_TASK_DATA";
export const GET_CART_DATA_TASK = "GET_CART_DATA_TASK";
export const UPDATE_CART_DATA_TASK = "UPDATE_CART_DATA_TASK";
export const GET_WALLET_DATA_TASK = "GET_WALLET_DATA_TASK";
export const UPDATE_WALLET_DATA_TASK = "UPDATE_WALLET_DATA_TASK";
export const GET_PROMOTION_DATA_TASK = "GET_PROMOTION_DATA_TASK";
export const UPDATE_PROMOTION_DATA_TASK = "UPDATE_PROMOTION_DATA_TASK";
export const GET_FEEDBACK_CART_TASK = "GET_FEEDBACK_CART_TASK";
export const UPDATE_FEEDBACK_CART_TASK = "UPDATE_FEEDBACK_CART_TASK";
export const GET_FEEDBACK_CASHBACK_TASK = "GET_FEEDBACK_CASHBACK_TASK";
export const UPDATE_FEEDBACK_CASHBACK_TASK = "UPDATE_FEEDBACK_CASHBACK_TASK";
export const SHOW_SNACKBAR_TASK = "SHOW_SNACKBAR_TASK";
export const RESET_SNACKBAR_CL_TASK = "RESET_SNACKBAR_CL_TASK";
export const RESET_CONFETTI_CL_TASK = "RESET_CONFETTI_CL_TASK";
export const SHOW_CONFETTI_TASK = "SHOW_CONFETTI_TASK";
export const TOGGLE_CL_TASK_LOADER = "TOGGLE_CL_TASK_LOADER";

// MyDeliveries
export const MY_DELIVERIES_FETCHING = "MY_DELIVERIES_FETCHING";
export const MY_DELIVERIES_FETCHED = "MY_DELIVERIES_FETCHED";
export const MY_DELIVERIES_FETCH_FAILD = "MY_DELIVERIES_FETCH_FAILD";

// Cl Tasks
const taskType = createTypes(
  `
  GET_TODAY_TASK_UPCOMING
  GET_TODAY_TASK_SUCCESS
  GET_TODAY_TASK_ERROR

  GET_CL_TASK_SUMMARY_UPCOMING
  GET_CL_TASK_SUMMARY_SUCCESS
  GET_CL_TASK_SUMMARY_ERROR
  GET_CL_TASK_SUMMARY_FETCHED

  ABANDONED_CART_UPCOMING
  ABANDONED_CART_SUCCESS
  ABANDONED_CART_ERROR
  ABANDONED_CART_FETCHED

  ABANDONED_CART_BUSINESS_UPCOMING
  ABANDONED_CART_BUSINESS_SUCCESS
  ABANDONED_CART_BUSINESS_ERROR
  ABANDONED_CART_BUSINESS_FETCHED

  GET_ABANDONED_FEEDBACK_UPCOMING
  GET_ABANDONED_FEEDBACK_SUCCESS
  GET_ABANDONED_FEEDBACK_ERROR
  GET_ABANDONED_FEEDBACK_FETCHED

  GET_WALLET_DATA_TASK_UPCOMING
  GET_WALLET_DATA_TASK_SUCCESS
  GET_WALLET_DATA_TASK_ERROR
  GET_WALLET_DATA_TASK_FETCHED

  WALLET_BUSINESS_TIPS_UPCOMING
  WALLET_BUSINESS_TIPS_SUCCESS
  WALLET_BUSINESS_TIPS_ERROR
  WALLET_BUSINESS_TIPS_FETCHED

  GET_WALLET_FEEDBACK_UPCOMING
  GET_WALLET_FEEDBACK_SUCCESS
  GET_WALLET_FEEDBACK_ERROR
  GET_WALLET_FEEDBACK_FETCHED

  PROMOTION_BUSINESS_TIPS_UPCOMING
  PROMOTION_BUSINESS_TIPS_SUCCESS
  PROMOTION_BUSINESS_TIPS_ERROR
  PROMOTION_BUSINESS_TIPS_FETCHED

  GET_PROMOTION_DATA_TASK_UPCOMING
  GET_PROMOTION_DATA_TASK_SUCCESS
  GET_PROMOTION_DATA_TASK_ERROR
  GET_PROMOTION_DATA_TASK_FETCHED

  CL_TASK_LOADING
  CL_SNACKBAR_LOADING
  CL_FIRE_LOADING
  SHOW_SNACKBAR_TASK
`,
  { prefix },
);

export { taskType };
// Deliveries v2
export const FETCH_RRD_INFO = "FETCH_RRD_INFO";
export const SET_RRD_INFO = "SET_RRD_INFO";

// Logged in other device
export const SET_LOGGEDIN_MODAL_DATA = "SET_LOGGEDIN_MODAL_DATA";

export const SET_LOGGED_IN_OPTIONS = "SET_LOGGED_IN_OPTIONS";

export const SET_LOGIN_RELATED_PARAMS = "SET_LOGIN_RELATED_PARAMS";

// app visibility
export const UPDATE_APP_VISIBILITY_SYNC_TIMESTAMP =
  "UPDATE_APP_VISIBILITY_SYNC_TIMESTAMP";

// home page widget
export const SET_HOME_PAGE_WIDGET = "SET_HOME_PAGE_WIDGET";
export const FETCH_HOME_PAGE_WIDGET = "FETCH_HOME_PAGE_WIDGET";
export const UPDATE_HOME_PAGE_WIDGET = "UPDATE_HOME_PAGE_WIDGET";
export const REPLACE_HOME_PAGE_WIDGET = "REPLACE_HOME_PAGE_WIDGET";

// new wallet screen
export const GET_WALLET_SUMMARY_REQ = "GET_WALLET_SUMMARY_REQ";
export const GET_WALLET_SUMMARY_SUCCESS = "GET_WALLET_SUMMARY_SUCCESS";
export const GET_WALLET_SUMMARY_FAIL = "GET_WALLET_SUMMARY_FAIL";
export const SET_TIME_FILTER = "SET_TIME_FILTER";
export const SET_TRANSACTION_FILTER = "SET_TRANSACTION_FILTER";
export const SET_WALLET_LOADING = "SET_LOADING";
export const SET_WALLET_TXN_TYPE = "SET_WALLET_TXN_TYPE";
export const GET_WALLET_METADATA_REQ = "GET_WALLET_METADATA_REQ";
export const GET_WALLET_METADATA_SUCCESS = "GET_WALLET_METADATA_SUCCESS";
export const GET_WALLET_METADATA_FAIL = "GET_WALLET_METADATA_FAIL";
export const GET_WALLET_TRANSACTIONS_REQ = "GET_WALLET_TRANSACTIONS_REQ";
export const GET_WALLET_TRANSACTIONS_SUCCESS =
  "GET_WALLET_TRANSACTIONS_SUCCESS";
export const GET_WALLET_TRANSACTIONS_FAIL = "GET_WALLET_TRANSACTIONS_FAIL";
export const RESET_WALLET_TRANSACTIONS_DATA = "RESET_WALLET_TRANSACTIONS_DATA";
export const SET_TRANSACTION_TYPE = "SET_TRANSACTION_TYPE";
export const GET_DISPUTE = "GET_DISPUTE";
export const GET_DISPUTE_SUCCESS = "GET_DISPUTE_SUCCESS";
export const GET_DISPUTE_FAIL = "GET_DISPUTE_FAIL";
export const SET_MODAL_API = "SET_MODAL_API";
export const GET_MODAL_REQ = "GET_MODAL_REQ";
export const GET_MODAL_SUCCESS = "GET_MODAL_SUCCESS";
export const GET_MODAL_FAIL = "GET_MODAL_FAIL";
export const SET_MODAL_LOADING = "SET_MODAL_LOADING";
export const RESET_FILTERS = "RESET_FILTERS";

export const FETCH_RETURNS_REQUEST = "FETCH_RETURNS_REQUEST";
export const FETCH_RETURNS_SUCCESS = "FETCH_RETURNS_SUCCESS";
export const FETCH_RETURNS_FAILURE = "FETCH_RETURNS_FAILURE";

// CP Delivery Routes
export const FETCH_DELIVERY_ROUTES_REQ = "FETCH_DELIVERY_ROUTES_REQ";
export const FETCH_DELIVERY_ROUTES_SUCCESS = "FETCH_DELIVERY_ROUTES_SUCCESS";
export const FETCH_DELIVERY_ROUTES_FAIL = "FETCH_DELIVERY_ROUTES_FAIL";
export const SET_DELIVERY_ROUTES_LOADING = "SET_DELIVERY_ROUTES_LOADING";
export const SELECT_DELIVERY_ROUTE = "SELECT_DELIVERY_ROUTE";
export const UPDATE_DRAFT_ROUTES = "UPDATE_DRAFT_ROUTES";
export const TOGGLE_EXPAND_STATE = "TOGGLE_EXPAND_STATE";
export const SET_SWITCH_DB_ID = "SET_SWITCH_DB_ID";
export const TOGGLE_SWITCH_DB_CONFIRM_MODAL = "TOGGLE_SWITCH_DB_CONFIRM_MODAL";
export const SET_CURRENT_DELIVERY_TAB = "SET_CURRENT_DELIVERY_TAB";
export const TOGGLE_SEARCH_ENABLED = "TOGGLE_SEARCH_ENABLED";
export const FILTER_ROUTES_BY_SEARCH = "FILTER_ROUTES_BY_SEARCH";
export const ASSIGN_TOUCHPOINT_BULK_REQ = "ASSIGN_TOUCHPOINT_BULK_REQ";
export const ASSIGN_TOUCHPOINT_BULK_SUCCESS = "ASSIGN_TOUCHPOINT_BULK_SUCCESS";
export const ASSIGN_TOUCHPOINT_BULK_FAIL = "ASSIGN_TOUCHPOINT_BULK_FAIL";
export const UPDATE_DB_ROUTE_REQ = "UPDATE_DB_ROUTE_REQ";
export const UPDATE_DB_ROUTE_SUCCESS = "UPDATE_DB_ROUTE_SUCCESS";
export const UPDATE_DB_ROUTE_FAIL = "UPDATE_DB_ROUTE_FAIL";
export const RESET_DELIVERY_ROUTES_STATE = "RESET_DELIVERY_ROUTES_STATE";

// MyTask

export const ADD_ORDER_MARKING = "ADD_ORDER_MARKING";
export const REMOVE_ORDER_MARKING = "REMOVE_ORDER_MARKING";
export const CLEAR_ORDER_MARKING = "CLEAR_ORDER_MARKING";
export const ADD_BULK_ORDER_MARKING = "ADD_BULK_ORDER_MARKING";

export const UPDATE_FACE_CAPTURE_DATA = "UPDATE_FACE_CAPTURE_DATA";

// Location (session-scoped, non-persisted slice — see locationReducer.js)

export const LOCATION_FIX_RECEIVED = "LOCATION_FIX_RECEIVED";
export const CLEAR_LOCATION_FIX = "CLEAR_LOCATION_FIX";

// Wallet V3
export const GET_WALLET_V3_SUMMARY_REQ = "GET_WALLET_V3_SUMMARY_REQ";
export const GET_WALLET_V3_SUMMARY_SUCCESS = "GET_WALLET_V3_SUMMARY_SUCCESS";
export const GET_WALLET_V3_SUMMARY_FAIL = "GET_WALLET_V3_SUMMARY_FAIL";
export const SET_WALLET_V3_LOADING = "SET_WALLET_V3_LOADING";
export const CLEAR_WALLET_V3_SUMMARY = "CLEAR_WALLET_V3_SUMMARY";
